

export default function NotFoundScreen() {
    return (
        <div>
            <h1>404</h1>
        </div>
    );
}
    